import {
  set as setLocalStorage,
  get as getLocalStorage,
} from 'lib/storage/isomorphicLocalStorage'
const LOCAL_STORAGE_DISMISS_USER_PREFERENCES_NOTIFICATION = 'userPreferencesNotificationDismissed'

export function dismissUserPreferencesNotificationLocally() {
  setLocalStorage(LOCAL_STORAGE_DISMISS_USER_PREFERENCES_NOTIFICATION, 'true')
}

export function getHasDismissedUserPreferencesNotificationLocally() {
  return getLocalStorage(LOCAL_STORAGE_DISMISS_USER_PREFERENCES_NOTIFICATION) === 'true'
}
